export default __webpack_public_path__ + "static/media/payngolinky-200x1000.ae921ad2.png";